/**
 * Utility functions for consistent date handling in Kenya (Africa/Nairobi, UTC+3).
 */

export const KENYA_TIMEZONE = 'Africa/Nairobi';

/**
 * Returns a date formatted as 'YYYY-MM-DD' in Kenya timezone (Africa/Nairobi).
 * Ensures that trips and reports use the local Kenya operational date regardless of UTC offsets.
 */
export function getKenyaDateString(date: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: KENYA_TIMEZONE }).format(date);
}
